export const generateServiceSchema = (service, pageUrl) => {
  const base = 'https://modernbuildremodel.com';

  return {
    "@context": "https://schema.org",
    "@type": "Service",
    "@id": `${pageUrl}#service`,
    "mainEntityOfPage": { "@id": `${pageUrl}#webpage` },
    "name": `${service.title} in Los Angeles, CA`,
    "serviceType": service.title.replace("/", "and"),
    "description": service.description,
    "url": pageUrl,
    "image": `${base}${service.image}`,
    "provider": {
      "@type": "LocalBusiness",
      "@id": `${base}#localbusiness`,
      "name": "Modern Build Home Remodeling",
      "url": base,
      "telephone": "+1-323-300-4130",
      "priceRange": "$$",
      "image": `${base}${service.image}`,
      "brand": { "@type": "Brand", "name": "Modern Build Home Remodeling" },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "4222 Longridge Ave",
        "addressLocality": "Studio City",
        "addressRegion": "CA",
        "postalCode": "91604",
        "addressCountry": "US"
      },
      "areaServed": [
        { "@type": "AdministrativeArea", "name": "Los Angeles County, CA" },
        { "@type": "AdministrativeArea", "name": "Orange County, CA" },
        { "@type": "AdministrativeArea", "name": "Ventura County, CA" }
      ]
    },
    "offers": [
      {
        "@type": "Offer",
        "url": pageUrl,
        "priceCurrency": "USD",
        "price": "0",
        "name": "Free Estimate",
        "description": "Get a free, no-obligation estimate for your project",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "url": `${pageUrl}#financing`,
        "name": "Financing Available",
        "description": "Flexible financing options with $0 down",
        "availability": "https://schema.org/InStock"
      }
    ]
  };
};